import type { HeroProps } from "./hero.types";

export function isWeddingPosterHero(
  props: HeroProps
): props is Extract<HeroProps, { layout: "wedding-poster" }> {
  return props.layout === "wedding-poster";
}
